(function ( root, factory ) {
    if ( typeof define === 'function' && define.amd ) {
        // AMD
        define( [
            'jquery'
        ], factory );
    } else if ( typeof exports === 'object' ) {
        // Node, CommonJS-like
        module.exports = factory(
            require( 'jquery' )
        );
    } else {
        // Browser globals (root is window)
        root.MLBTokenHelpers = factory(
            root.jQuery
        );
    }

})( this, function ( $ ) {
    /**
     * Helper functions for replacing track prop tokens.
     */
    var MLBTokenHelpers = {
        'SITE_NAME': function ( screenData ) {
            return this.pageConfig.teamDisplay || 'Major League Baseball';
        },
        'AD_BLOCK_CONTEXT_ERROR': function ( screenData ) {
            //s.prop14 = Major League Baseball: Video Tray: AdBlock: Playback Error - Disable Ad Block
            var teamCode = this.pageConfig.teamAbbrev || 'MLB';

            var playerContext = teamCode + ": " + this.pageConfig.playerContext;
            if ( !playerContext ) {
                playerContext = teamCode + ": Video Playback Page";
            }

            playerContext = playerContext.replace(/\+/g, '%20');
            playerContext = decodeURIComponent(playerContext);

            return playerContext + ": AdBlock On";

        },
        // MEDIA.
        'MEDIA_SPONSOR': function ( screenData ) {
            return 'MLB';
        },
        'MEDIA_TOPIC_NAME': function ( screenData ) {
            return this.pageConfig.topicName;
        },
        'MEDIA_SYSTEM_AUTO_PLAY': function ( screenData ) {
            return this.pageConfig.systemAutoPlay;
        },
        'MEDIA_EMBED_HOST': function ( screenData ) {
            return (this.embedParent && this.embedParent.hostname) ? this.embedParent.hostname : getEmbedParent.call( this, 'hostname' );
        },

        'MEDIA_STREAM_TITLE': function ( screenData ) {
            var streamTitle = "";

            if ( screenData.meta && Object.keys( screenData.meta ).length ) { // Highlights|VPP|Embed: seoTitle.
                streamTitle = screenData.meta.seoTitle || screenData.meta.title || screenData.meta.blurb || "";
            } else if ( screenData.clip && Object.keys( screenData.clip ).length ) {
                streamTitle = screenData.clip.seoTitle || screenData.clip.title || screenData.clip.blurb || "";
            }

            if ( streamTitle == "" && screenData.dynamicVars.title ) {
                streamTitle = screenData.dynamicVars.title;
            }

            return streamTitle;
        },
        'MEDIA_STREAM_ID': function ( screenData ) {
            var streamId = null;

            if ( screenData.player.playerStateHelper ) {
                streamId = screenData.player.playerStateHelper._state.clip.content_id + '|' + screenData.player.playerStateHelper._state.clip.metaData.currentPlaybackScenario;
            } else if ( screenData.clip && screenData.meta ) {
                streamId = screenData.clip.content_id + '|' + screenData.meta.currentPlaybackScenario;
            }

            return streamId;
        },
        'MEDIA_PLAYER_CONTEXT': function ( screenData ) {
            var teamCode = this.pageConfig.teamAbbrev || 'MLB';

            var playerContext = this.pageConfig.playerContext;
            if ( !playerContext ) {
                playerContext = "Video Playback Page";
            } else if ( typeof playerContext === 'string' ) {
                if ( playerContext.indexOf('_articles') > -1 ) {
                    playerContext = "Embedded Article Player";
                } else if (playerContext.indexOf("_mixed_feed") > -1) {
                    playerContext = teamCode + " Mixed Panel Player";
                } else if (playerContext.indexOf("_video_tray") > -1) {
                    playerContext = teamCode + " Video Tray";
                }
            }

            playerContext = playerContext.replace(/\+/g, '%20');
            playerContext = decodeURIComponent(playerContext);

            return playerContext || null;
        },
        'MEDIA_PlAYER_LOCATION' : function ( screenData ) {
            var teamCode = this.pageConfig.teamAbbrev || 'MLB';

            var playerLocation = this.pageConfig.playerLocation || this.pageConfig.playerContext;
            if ( !playerLocation ) {
                playerLocation = "Video Embed Player";
            }

            playerLocation = playerLocation.replace(/\+/g, '%20');
            playerLocation = decodeURIComponent(playerLocation);

            return playerLocation || null;
        },
        'MEDIA_INDEX_NAME': function ( screenData ) {
            // TODO.
            //playerFlavor   : _config.topicName,
            //videoIndex     : clip.metaData.indexName

            var keywords = screenData.meta.keywords || {};

            for ( var keyword in keywords ) {
                if ( keywords[keyword] && keywords[keyword].type == 'mlbtax' ) {
                    return keywords[keyword].displayName;
                }
            }

            return null;
        },
        'CURRENT_TIME_STAMP': function() {
            //date format is taken from /site-core/AppMeasurement-mlb.js, for prop35
            var d = new Date();
            return (d.getUTCMonth() + 1) + '/' + d.getUTCDate() + '/' + d.getUTCFullYear() + ' ' + (d.getUTCHours() - 4) + ':' + d.getUTCMinutes() + ':' + d.getUTCSeconds();
        },
        'MEDIA_EMBED_HOST': function ( screenData ) {
            return (this.embedParent && this.embedParent.hostname) ? this.embedParent.hostname : getEmbedParent.call( this, 'hostname' );
        },
        'GAMEDAY_GAME_ID': function ( screenData ) {
            return screenData.meta.game_id ? screenData.meta.game_id : null;
        },
        'GAMEDAY_GAME_PK': function ( screenData ) {
            return screenData.meta.game_pk ? screenData.meta.game_pk : null;
        },
        'MEDIA_PLAYER_VERSION': function ( screenData ) {
            var versionName;
            var playerType = screenData.player.toString();

            switch ( playerType ) {
                case 'MultiViewFlashPlayer':
                case 'FlashPlayer':
                    versionName = 'flash';
                    break;
                case 'HTML5Player':
                    versionName = 'html5';
                    break;
                case 'DashPlayer':
                    versionName = 'html5:DashPlayer';
                    break;
                case 'PrimetimePlayer':
                    versionName = 'html5:PrimetimePlayer';
                    break;
                default:
                    versionName = 'Player version not found';
            }

            return versionName;
        }
    };


    /**
     * Get the embed's parent window information.
     * @param returnValue
     * @returns {*}
     */
    function getEmbedParent( returnValue ) {
        var host;
        var locale = 'nil';

        if ( window === window.parent && window.parent.location ) {
            host = window.parent.location;
        } else {
            host      = document.createElement( 'a' );
            host.href = document.referrer;
        }

        this.embedParent = {
            hostname: host.hostname,
            locale:   locale
        };

        if ( returnValue ) {
            return this.embedParent[ returnValue ];
        } else {
            return this.embedParent;
        }
    }


    return MLBTokenHelpers;
} );